import { useEffect } from "react";

import { useAskPerformYardStore } from "../AskPerformYardStore";

/**
 * Hide the Ask PerformYard FAB + chat window while `active` is true — e.g. while an
 * AI summarization / insights panel is open — so it doesn't overlap the panel's
 * Copy to Clipboard / footer actions. Visibility is restored on deactivate/unmount.
 */
export const useSuppressAskPerformYard = (active: boolean): void => {
	const setForceHidden = useAskPerformYardStore((state) => state.setForceHidden);

	useEffect(() => {
		setForceHidden(active);
		return () => setForceHidden(false);
	}, [active, setForceHidden]);
};
